import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: 'Paginate',
  props: {
    pageSize: {
      type: [Number, String],
      default: () => 10
    },
    amount: {
      type: [Number, String],
      required: true
    },
    total: {
      type: [Number, String],
      required: true
    }
  },
  emits: [
    'currentPageChange'
  ],
  setup: (props, context) => {
    const currentPage = ref(1);
    const maxPage = computed(() => Math.ceil(Number(props.amount) / Number(props.pageSize)));
    const pageList = computed(() => calulatePageList());

    const previousClick = () => {
      Promise.resolve(currentPage.value--)
        .then(() => context.emit('currentPageChange', currentPage.value));
    };

    const nextClick = () => {
      Promise.resolve(currentPage.value++)
        .then(() => context.emit('currentPageChange', currentPage.value));
    };

    const pageClick = (page: number) => {
      Promise.resolve(currentPage.value = page)
        .then(() => context.emit('currentPageChange', currentPage.value));
    };

    const calulatePageList = () => {
      const pageArray = Array.from({length: maxPage.value}, (_, index) => index + 1);
      const start = (currentPage.value - 2 > 1)
        ? (maxPage.value - (currentPage.value - 2) > 5)
          ? currentPage.value - 2
          : maxPage.value - 4
        : 1;
      const end = (currentPage.value + 2 < maxPage.value)
        ? (currentPage.value + 2 > 5)
          ? currentPage.value + 2
          : 5
        : maxPage.value;

      return pageArray.slice(start - 1, end);
    };

    const start = computed(() => props.amount !== 0
      ? (Number(props.pageSize) * (currentPage.value - 1)) + 1
      : 0);
    const end = computed(() => Number(props.pageSize) + (Number(props.pageSize) * (currentPage.value - 1)) <= props.amount
      ? Number(props.pageSize) + (Number(props.pageSize) * (currentPage.value - 1))
      : props.amount);

    return {
      currentPage,
      maxPage,
      pageList,
      start,
      end,
      previousClick,
      nextClick,
      pageClick
    };
  }
});
